import React, { DetailedHTMLProps, useCallback, useContext, useEffect, useState } from 'react'
import { BiInfoCircle } from 'react-icons/bi'
import ReactInputMask from 'react-input-mask'
import { useNavigate } from 'react-router-dom'
import RegisterOscContext from '../../../context/RegisterContext'
import useApi from '../../../hooks/useApi'
import { Button } from '../../../Korbantech/components/Buttons/Button'
import Modal from '../../../Korbantech/components/Modal'
import { Osc } from '../../../types/Osc'


export const CnpjInput = React.forwardRef<HTMLInputElement, Props>( ( { cad,label, important,necessary, info, oldValue, ...props }, ref ) => {

    const api = useApi()
    const navigate = useNavigate()

    const [cnpj,setCnpj] = useState<string>("")
    const [modal ,setModal] = useState<boolean>(false)
    const [modalInfo,setModalInfo] = useState<{text:string,buttonText:string}|undefined>(undefined)
    const { setOsc} = useContext(RegisterOscContext)
    const [tmpOsc,setTmpOsc] = useState<Osc>()
    
    const checkCnpj =  useCallback(async ()=>{
        let document = cnpj.replaceAll("_","").replaceAll("-","").replaceAll(".","").replace("/","")
        if(document.length === 14){
            const params = {
                document:document
            }
            await api.get(`/osc/check-document`,{params}).then(res => {
                return 
            }
            ).catch(err => {
                if(err.response.status === 423)
                setModalInfo({
                    text:"CNPJ já cadastrado",
                    buttonText:"Ir para login",
                })
                setModal(true)

            if(err.response.status === 424)
                setModalInfo({
                    text:"Já foi iniciado um cadastro com esse CNPJ",
                    buttonText:"Continuar",
                })
                setTmpOsc(err.response.data.osc)
            })
        }
    },[cnpj,setModalInfo,setModal,setTmpOsc,api])

    const actionModal = useCallback(()=>{
        if(!tmpOsc) return navigate("/osc/login")
        setOsc(tmpOsc)
        setModal(false);
    },[tmpOsc,setOsc,navigate])

    useEffect(()=>{
        if(cad)
        checkCnpj()
    },[checkCnpj,cad])


    return (
        <div className=''>
            <label className='flex justify-between'>
                <div className='flex items-center'>
                    {label}
                    {important && <BiInfoCircle className='text-primary-dark ml-1' />}
                </div>
                {!necessary && <div className='text-sm italic '>opcional</div>}
            </label>
            <ReactInputMask
                required
                value={cnpj}
                onChange={(e)=>setCnpj(e.target.value)}
                name={props.name}
                mask={"99.999.999/9999-99"}
                placeholder="00.000.000/0000-00"
                className="w-full focus:outline-none h-10 border px-2" />
            <div className='text-gray-500 text-sm'>{info}</div>
            <Modal open={modal} onClickCloseButton={() => setModal(false)}>
                   <div>
                        {modalInfo?.text}
                        <Button value={modalInfo?.buttonText} onClick={actionModal}/>
                   </div>
            </Modal>
        </div>
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {
    label: string,
    important?: boolean,
    necessary?:boolean
    info?:string
    oldValue?:string
    cad?:boolean
}
